import DataTable from 'react-data-table-component';
import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES } from './../../common/helper/common-imports.component.js';
import CryptoService from "../../../services/crypto-service.js";

import { cryptoConfigColumns } from './crypto-config.col.component.js'
import { customDataTableStyles } from '../../common/helper/data-table.styles.js';

const CryptoConfig = () => { 
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dataTableKey, setDataTableKey] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const dispatch = useDispatch();

  const [crypto, setCrypto] = useState([]);
 
  const [cols,setCols] = useState(cryptoConfigColumns())

  
  const getCryptoList = (e) => {
    setLoading(true);
    CryptoService.getCryptoList()
      .then(response => {
        setCrypto(response.data.data)
   
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
   
  }
  useEffect(() => {
    getCryptoList();
    document.body.style.backgroundImage = '';
    document.body.style.backgroundColor = '#f0f6fa';
    
    return () => {
      document.body.style.backgroundColor = '';
    };
  }, []);
  const navigate = useNavigate();


  
const handleSearchChange = (e) => {
  setSearchTerm(e.target.value);
};




const resetSearch = (tab) => {
  setRowsPerPage(10);

  setSearchTerm('');
}
useEffect(() => {
    if (crypto?.length) {
      const element = document.getElementsByClassName("sc-bHCmUC");
      const childElement = element[0].children;
      for (let i = 0; i < childElement?.length; i++) {
        const ele = childElement[i].id.split("-")[1];
        if (Number(ele) % 2 === 0) {
          childElement[i].classList.add("even-transaction-table");
        } else {
          childElement[i].classList.add("odd-transaction-table");
        }
      }
    }
  }, [crypto]);


  return (
    <div>
            <LoaderOverlay loading={loading} />

    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
                    <div className="container" style={{backgroundColor: 'white'}}>
                      <nav>
                        <div className="nav nav-tabs" id="nav-tab" role="tablist" >
                          <button className="nav-link active tbbtn" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true" onClick={() => resetSearch('approved')}> Crypto Config </button>
           
                        
                        </div>
                      </nav>
    
          
                    
                      <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px'}}>
                        <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab" style={{position: 'relative'}}>

                        <div className="multi">
                          <span className="DataTables_sort_icon css_right ui-icon ui-icon-triangle-1-n" /></div>

                        <DataTable key={dataTableKey}
                            columns={cols}
                              data={crypto}
                              customStyles={customDataTableStyles}
                             
                        />
                        </div>
                     
                      
                      </div>
                    </div>
                  </div>
                  
                  </div>
               

)

}
function mapStateToProps(state) {
   const userData = state.authReducer.user;
   return { userData };
 }
 export default withAuth(connect(mapStateToProps)(CryptoConfig));

 
 
